import { EffectMap } from '~/client/src/shared/stores/EventStore/BaseEvents.store'
import EffectsProcessor from '~/client/src/shared/stores/EventStore/EffectsProcessors/EffectsProcessor'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import EventTypes from '~/client/src/shared/stores/EventStore/eventTypes'
import InitialState from '~/client/src/shared/stores/InitialState'

type LoginEventHandler = (
  state: InitialState,
  ...args: any[]
) => void | EffectMap

export default class LoginEventsStore extends EventsStore {
  public constructor(
    public effectProcessor: EffectsProcessor,
    public appState: InitialState,
  ) {
    super(effectProcessor, appState)
  }

  public dispatch(type: EventTypes, ...args: any[]) {
    return super.dispatch.call(this, type, ...args)
  }

  public on(type: EventTypes, handler: LoginEventHandler) {
    return super.on.call(this, type, handler)
  }
}
